import { render, staticRenderFns } from "./goodsOne.vue?vue&type=template&id=2b7ea246&scoped=true&"
import script from "./goodsOne.vue?vue&type=script&lang=ts&"
export * from "./goodsOne.vue?vue&type=script&lang=ts&"
import style0 from "./goodsOne.vue?vue&type=style&index=0&id=2b7ea246&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ea246",
  null
  
)

export default component.exports